import { ResultFilterModel, ResultFilterUIMode } from "../../../../client/swaggerClient";
import { Colors } from "../FindDesignTypes";
import FilterCategory from "./FilterCategory";
import FilterCheckBox from "./FilterCheckBox";
import FilterDropDown from "./FilterDropDown";
import FilterFindQuery from "./FilterFindQuery";
import FilterLongInterval from "./FilterLongInterval";
import FilterOptions from "./FilterOptions";
import FilterCondition from "./FilterCondition";
import FilterRadioButtons from "./FilterRadioButtons";
import FilterSliderIntervalInteger from "./FilterSliderIntervalInteger";
import FilterCheckBoxList from "./FilterCheckboxList";
import FilterIntervalDropDown from "./FilterIntervalDropDown";
import FilterOptionsMultiselect from "./FilterOptionsMultiselect";

// Itt lehet beállítani hogy max ennyit filter opciót mutasson egyszerre, ha többb va
// akkor megjelenik egy gomb hogy mutass többet, ha 10 vagy kevesebb opció van
// akkor megjelenik mind
export const MAX_FILTER_SHOW = 10

const getFilterType = (
  filters: ResultFilterModel,
  colors: Colors,
  pageUrl?: string,
  mmbr?: string | string[],
  isMobile?: boolean,
  closeSubmenu?: () => void
) => {
  switch(filters.uiMode) {
    case ResultFilterUIMode.Options:
      return <FilterOptions filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} closeSubmenu={closeSubmenu} />
    case ResultFilterUIMode.OptionsMultiselect:
      return <FilterOptionsMultiselect filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} closeSubmenu={closeSubmenu} />
    case ResultFilterUIMode.DropDown:
      return <FilterDropDown filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.FindQuery:
      return <FilterFindQuery filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.CheckBox:
      return <FilterCheckBox filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.LongInterval:
      return <FilterLongInterval filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.Categories:
      return <FilterCategory filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} closeSubmenu={closeSubmenu} />
    case ResultFilterUIMode.UjVagyHasznalt:
      return <FilterCondition filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.RadioButtons:
      return <FilterRadioButtons filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} closeSubmenu={closeSubmenu} />
    case ResultFilterUIMode.CheckboxList:
      return <FilterCheckBoxList filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.IntervalDropDown:
      return <FilterIntervalDropDown filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
    case ResultFilterUIMode.SliderIntervalInteger:
      return <FilterSliderIntervalInteger filters={filters} colors={colors} pageUrl={pageUrl} mmbr={mmbr} isMobile={isMobile} />
  }

}

export default getFilterType